var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaciente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m227.611 86.479h231.164v90.735h-231.164z",
    fill: "#688d97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.815 437.809v63.889c0 5.69-4.612 10.302-10.302 10.302h-280.641c-5.69 0-10.302-4.612-10.302-10.302v-63.889c0-71.363 57.851-129.215 129.215-129.215h42.815c71.363 0 129.215 57.852 129.215 129.215z",
    fill: "#21c1f8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.7 424.156v87.844h-15.453v-87.844c0-4.265 3.462-7.726 7.726-7.726 4.266 0 7.727 3.461 7.727 7.726z",
    fill: "#1faaee"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m259.142 424.156v87.844h-15.453v-87.844c0-4.265 3.451-7.726 7.726-7.726 4.266 0 7.727 3.461 7.727 7.726z",
    fill: "#1faaee"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m493.816 437.813v63.881c0 5.69-4.612 10.302-10.302 10.302h-24.606v-74.183c0-71.366-57.852-129.218-129.208-129.218h34.898c71.365-.001 129.218 57.852 129.218 129.218z",
    fill: "#1faaee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.601 277.67v48.767c0 15.133-12.274 27.406-27.406 27.406-15.144 0-27.418-12.274-27.418-27.406v-48.767z",
    fill: "#fdb0a0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9a08f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.601 277.67v36.77c-8.292 3.743-17.583 5.842-27.406 5.842-9.824 0-19.125-2.099-27.418-5.842v-36.77z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.575,
    cy: 180.147,
    r: 31.392
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.81,
    cy: 180.147,
    r: 31.392
  })), /*#__PURE__*/React.createElement("path", {
    d: "m433.698 138.882v60.303c0 49.909-39.917 91.257-89.826 91.638-50.3.361-91.195-40.287-91.195-90.505v-61.436c0-49.991 40.535-90.505 90.516-90.505 25.001 0 47.622 10.126 64.001 26.505 16.368 16.389 26.504 39.01 26.504 64z",
    fill: "#fdb0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.698 138.882v13.165c-7.262 2.38-14.988 3.636-22.94 3.636h-135.12c-7.952 0-15.678-1.267-22.961-3.647v-13.154c0-49.991 40.535-90.505 90.516-90.505 25.001 0 47.622 10.126 64.001 26.505 16.368 16.389 26.504 39.01 26.504 64z",
    fill: "#f9a08f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.352 0c-39.732 0-74.106 28.304-81.014 67.431-.521 2.952-.948 5.944-1.277 8.97-.956 8.803.301 17.71 3.671 25.899l.012.029c8.154 19.816 27.464 32.751 48.892 32.751h135.125c21.451 0 40.776-12.961 48.916-32.808 3.352-8.174 4.6-17.059 3.648-25.842-.329-3.036-.757-6.037-1.28-8.998-6.908-39.127-41.282-67.432-81.014-67.432z",
    fill: "#3f5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.633 82.165c0 6.881-1.339 13.711-3.955 20.108-8.138 19.85-27.463 32.809-48.92 32.809h-32.201c21.457 0 40.782-12.959 48.92-32.809 2.616-6.397 3.955-13.226 3.955-20.108 0-1.906-.103-3.822-.309-5.738-.33-3.028-.752-6.037-1.277-8.993-6.912-39.134-41.287-67.431-81.018-67.431h32.201c39.731 0 74.106 28.297 81.018 67.431.525 2.956.948 5.964 1.277 8.993.206 1.916.309 3.832.309 5.738z",
    fill: "#384848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.079 456.117h-24.697c-5.69 0-10.302-4.612-10.302-10.302v-24.697c0-5.69 4.612-10.302 10.302-10.302h24.697c5.69 0 10.302 4.612 10.302 10.302v24.697c-.001 5.69-4.613 10.302-10.302 10.302z",
    fill: "#24d1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.378 421.116v24.704c0 5.687-4.605 10.302-10.302 10.302h-22.643c5.687 0 10.302-4.615 10.302-10.302v-24.704c0-5.687-4.615-10.302-10.302-10.302h22.643c5.697 0 10.302 4.615 10.302 10.302z",
    fill: "#21c1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.063 241.187c-.824.262-1.714.262-2.538 0-21.716-6.906-38.63-18.584-50.335-34.772-2.212-3.06-4.047-6.034-5.56-8.801-4.127-7.548-6.232-16.035-6.232-24.637v-64.189c0-1.944 1.329-3.636 3.218-4.096l59.18-14.412c.655-.16 1.34-.16 1.995 0l59.18 14.412c1.889.46 3.218 2.152 3.218 4.096v70.42c0 2.521-.424 5.022-1.269 7.397-1.665 4.685-4.85 11.965-10.524 19.811-11.703 16.187-28.617 27.865-50.333 34.771z",
    fill: "#31a7fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.185 108.787v70.423c0 2.514-.422 5.017-1.267 7.397-1.659 4.677-4.842 11.96-10.518 19.81-11.703 16.184-28.618 27.866-50.335 34.769-.824.258-1.72.258-2.545 0-7.191-2.287-13.856-5.1-19.975-8.427 20.346-6.995 36.283-18.348 47.46-33.81 5.676-7.85 8.86-15.123 10.528-19.81.845-2.38 1.267-4.883 1.267-7.397v-70.423c0-.793-.216-1.535-.597-2.174l22.767 5.543c1.886.463 3.215 2.152 3.215 4.099z",
    fill: "#1c96f9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m385.844 170.016-.088-.001c-.03-.001-.06-.001-.091-.001-4.224 0-7.632 3.401-7.68 7.638-.049 4.267 3.413 7.767 7.681 7.815.03.001.06.001.091.001 4.225 0 7.675-3.401 7.723-7.638.05-4.267-3.368-7.766-7.636-7.814z",
    fill: "#3f5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.715 170.015h-.086c-4.268 0-7.684 3.459-7.684 7.726 0 4.268 3.502 7.726 7.77 7.726s7.726-3.459 7.726-7.726c.001-4.267-3.458-7.726-7.726-7.726z",
    fill: "#3f5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.581 274.145c-1.45-1.449-3.414-2.263-5.464-2.263h-138.206c-4.268 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h135.006l72.985 72.987c1.509 1.508 3.486 2.263 5.464 2.263 1.977 0 3.955-.755 5.464-2.263 3.017-3.018 3.017-7.909 0-10.928z",
    fill: "#eff5f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.701 309.507h-97.722c-4.268 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h97.722c4.268 0 7.726-3.459 7.726-7.726s-3.458-7.726-7.726-7.726z",
    fill: "#21c1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.701 336.636h-55.671c-4.268 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h55.671c4.268 0 7.726-3.459 7.726-7.726s-3.458-7.726-7.726-7.726z",
    fill: "#7da2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.701 363.764h-55.671c-4.268 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h55.671c4.268 0 7.726-3.459 7.726-7.726s-3.458-7.726-7.726-7.726z",
    fill: "#7da2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.177 169.257h10.89v10.89c0 4.268 3.459 7.726 7.726 7.726 4.268 0 7.726-3.459 7.726-7.726v-10.89h10.89c4.268 0 7.726-3.459 7.726-7.726s-3.459-7.726-7.726-7.726h-10.89v-10.89c0-4.268-3.459-7.726-7.726-7.726-4.268 0-7.726 3.459-7.726 7.726v10.89h-10.89c-4.268 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726z",
    fill: "#eff5f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.854 214.291c-4.277-.142-7.846 3.178-8 7.443-.364 10.092-8.563 17.997-18.666 17.997-10.104 0-18.303-7.904-18.666-17.996-.153-4.265-3.737-7.602-7.999-7.444-4.265.154-7.598 3.735-7.444 7.999.664 18.445 15.646 32.893 34.109 32.893 18.461 0 33.444-14.448 34.109-32.892.154-4.265-3.178-7.846-7.443-8z",
    fill: "#fc7c6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaciente);
export default __webpack_public_path__ + "static/media/paciente.3adf34cb27e73fad148cde24c469995a.svg";
export { ForwardRef as ReactComponent };